import { createFileRoute, useParams } from '@tanstack/react-router'
import { MoonIcon, SunIcon } from 'lucide-react'
import { TransitionTabsSurface } from './-components/shared/transition-tabs'

// A report tab that hosts its OWN tab pager: a lateral surface inside a lateral surface inside a stacked screen.
export const Route = createFileRoute('/_app/dev-resources/transitions/jobs/$jobId/distribution')({
  component: DistributionPane,
})

function DistributionPane() {
  const { jobId } = useParams({ from: '/_app/dev-resources/transitions/jobs/$jobId/distribution' })
  // oxlint-disable-next-line no-unsafe-type-assertion -- the concrete path of that very route; see ReportTabs
  const scope =
    `/dev-resources/transitions/jobs/${jobId}/distribution` as '/dev-resources/transitions/jobs/$jobId/distribution'
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <h2 className="p-4 pb-0 text-base font-semibold">Distribution</h2>
      <TransitionTabsSurface
        scope={scope}
        tabs={[
          { segment: 'x', label: 'By level', icon: SunIcon },
          { segment: 'y', label: 'By function', icon: MoonIcon },
        ]}
      />
    </div>
  )
}
